import {OrbitStartupFunctions} from "../orbit-startup-functions";

export function isHybridEmbedded(): boolean {
    return OrbitStartupFunctions.isHybridEmbedded();
}
